/* hp26 v5k (draft): social wall slider + lazy in-view videos. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var soundOn = null; // the one video allowed to have sound

  function setSound(v, on) {
    var b = v.parentNode.querySelector('[data-sw-sound]');
    v.muted = !on;
    if (b) { b.setAttribute('aria-pressed', on ? 'true' : 'false'); b.setAttribute('aria-label', on ? 'Turn sound off' : 'Turn sound on'); }
    if (on) {
      if (soundOn && soundOn !== v) setSound(soundOn, false);
      soundOn = v;
    } else if (soundOn === v) { soundOn = null; }
  }
  function load(v) {
    if (!v.dataset.loaded && v.dataset.src) { v.src = v.dataset.src; v.dataset.loaded = '1'; }
  }
  function play(v) {
    load(v);
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }
  function syncPlay(v) {
    var b = v.parentNode.querySelector('[data-sw-play]');
    if (b) { b.setAttribute('aria-label', v.paused ? 'Play video' : 'Pause video'); b.classList.toggle('is-playing', !v.paused); }
  }

  function init(root) {
    if (root.dataset.swInit) return;
    root.dataset.swInit = '1';
    var vp = root.querySelector('[data-sw-vp]');
    var prev = root.querySelector('[data-sw-prev]');
    var next = root.querySelector('[data-sw-next]');
    if (!vp) return;

    function step() {
      var c = vp.querySelector('.hp26-swc');
      if (!c) return vp.clientWidth;
      var gap = parseFloat(getComputedStyle(vp).columnGap) || 0;
      var per = Math.max(1, Math.floor((vp.clientWidth + gap) / (c.getBoundingClientRect().width + gap)));
      return per * (c.getBoundingClientRect().width + gap);
    }
    function atEnd() { return vp.scrollLeft + vp.clientWidth >= vp.scrollWidth - 4; }
    function go(dir) {
      var max = vp.scrollWidth - vp.clientWidth;
      if (dir > 0 && atEnd()) vp.scrollTo({ left: 0, behavior: reduce ? 'auto' : 'smooth' });
      else if (dir < 0 && vp.scrollLeft <= 4) vp.scrollTo({ left: max, behavior: reduce ? 'auto' : 'smooth' });
      else vp.scrollBy({ left: dir * step(), behavior: reduce ? 'auto' : 'smooth' });
    }
    function navState() {
      var scrollable = vp.scrollWidth > vp.clientWidth + 4;
      [prev, next].forEach(function (b) { if (b) b.disabled = !scrollable; });
    }
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    vp.addEventListener('keydown', function (e) {
      if (e.target !== vp) return;
      if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
    });
    navState();
    window.addEventListener('resize', navState, { passive: true });

    var vids = [].slice.call(root.querySelectorAll('[data-sw-video]'));
    vids.forEach(function (v) {
      v.addEventListener('playing', function () { v.classList.add('is-on'); syncPlay(v); });
      v.addEventListener('pause', function () { syncPlay(v); });
      var sb = v.parentNode.querySelector('[data-sw-sound]');
      if (sb) sb.addEventListener('click', function () {
        var on = v.muted;
        setSound(v, on);
        if (on && v.paused) play(v);
      });
      var pb = v.parentNode.querySelector('[data-sw-play]');
      if (pb && reduce) {
        pb.hidden = false;
        pb.addEventListener('click', function () { if (v.paused) play(v); else v.pause(); });
      }
    });
    if (!vids.length) return;
    if (!('IntersectionObserver' in window)) { if (!reduce) vids.forEach(play); return; }
    // No src until a card is at least half on screen (see load()); pause again when it leaves.
    var vis = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting && e.intersectionRatio >= 0.5) { if (!reduce) play(v); }
        else if (!v.paused) { v.pause(); if (!v.muted) setSound(v, false); }
      });
    }, { threshold: [0, 0.5] });
    vids.forEach(function (v) { vis.observe(v); });
  }

  function boot() {
    var go = function () { [].forEach.call(document.querySelectorAll('[data-sw]'), init); };
    if (document.readyState === 'complete') go(); else window.addEventListener('load', go);
  }
  boot();
  document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('[data-sw]'); if (r) init(r); });
})();
